import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const queryWhatIsNew = groq`*[_type == "whatIsNew" && currentPathname == $currentPathname][0]{
  ...,
"blogHero": {
  title,
  "backgroundImg": heroImage,
  "date":articleDate,
  heroImage {
    asset-> {
      altText
    }
  },
  readTime,
  taxonomies[]->,
  person {
      reference->
    }
},
CTABanner {
  reference -> ${CTABannerRefProjection}
},
}`;
